import { render, staticRenderFns } from "./AgentEdit.vue?vue&type=template&id=5404ffd5&scoped=true&"
import script from "./AgentEdit.vue?vue&type=script&lang=js&"
export * from "./AgentEdit.vue?vue&type=script&lang=js&"
import style0 from "./AgentEdit.vue?vue&type=style&index=0&id=5404ffd5&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5404ffd5",
  null
  
)

export default component.exports